import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'autocompleteOptions'
})
export class AutocompleteOptionsPipe implements PipeTransform {
  transform(value: () => Observable<any[]> | null): Observable<any[]> {
    if (value) {
      return value();
    }
    return of([]);
  }
}
